// Стандартная аякс-форма
import Analytics from "../marketing/analytics";
import popupsState from "../popups/popups-state";

const template = `
    <form :id="id" :action="action" method="post" @submit.prevent="submit">
        <slot :errors="errors"></slot>
        <transition name="slide-in">
            <div v-if="getFormError()" class="form-errors" v-html="getFormError()"></div>
        </transition>
        <slot name="captcha"></slot>
        <div v-if="submitText" class="form-button-wrapper">
            <input
                type="submit"
                class="button"
                :class="submitClass"
                :value="submitText"
                :disabled="isDisabled"
            />
        </div>
    </form>`;

const props = {
    id: String,
    action: {
        type: String,
        required: true,
    },
    submitText: String,
    submitClass: String,
    reachGoalOnSuccess: { type: Object },
    shouldClearErrors: { type: Boolean },
};

const data = function () {
    return {
        isDisabled: false,
        errors: {},
        result: {},
    };
};

const methods = {
    async submit() {
        try {
            this.isDisabled = true;
            this.clearErrors();

            const options = this.getRequestOptions();
            const response = await fetch(this.action, options);

            if (response.status !== 200) {
                const textResult = await response.text();
                this.handleServerErrors(response.status, textResult);
                return;
            }

            this.result = await response.json();
            this.processResult();
        } catch (err) {
            console.error(err);
            this.setError("Не удалось обработать запрос");
        } finally {
            this.isDisabled = false;
        }
    },

    getRequestOptions() {
        return {
            method: "POST",
            body: new URLSearchParams(new FormData(this.$el))
                .toString(),
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
        };
    },

    clearErrors() {
        this.errors = {};
    },

    handleServerErrors(status, textResult) {
        if (status === 204) {
            // в черном списке
            this.setError("Запрос заблокирован. Попробуйте отключить VPN.");
            return;
        }

        if (status === 403) {
            if (textResult.indexOf("CSRF") >= 0) {
                // csrf token verification fail
                window.location.reload();
                return;
            }
            this.setError(textResult);
            return;
        }

        this.setError("Ошибка сервера. Пожалуйста, попробуйте позже.");
    },

    processResult() {
        if (this.result === undefined) {
            this.setError("Выключите VPN и попробуйте еще раз.");
            return;
        }

        if (this.resultHasErrors()) {
            this.errors = this.result.form.errors;
            if (this.getFormError()
                ?.includes("Пройдите проверку на человека")) {
                this.$emit("captchaFail");
            }
            return;
        }

        if (!this.result.success) {
            return;
        }

        if (this.reachGoalOnSuccess?.goalName) {
            const {
                goalName,
                params,
                postfix,
                reachOnce,
            } = this.reachGoalOnSuccess;

            if (reachOnce) {
                Analytics.reachGoalOnce(goalName, postfix, params);
            } else {
                Analytics.reachGoal(goalName, params);
            }
        }

        if (this.result.success_message) {
            this.showSuccessMessage();
            return;
        }

        if (this.result.redirect_to) {
            window.location.replace(this.result.redirect_to);
            return;
        }

        this.hidePopups();
    },

    showSuccessMessage() {
        let onOpen;
        if (this.result.redirect_to) {
            onOpen = () => {
                window.location.replace(this.result.redirect_to);
            };
        }
        popupsState.dispatchOpen({
            newPopupId: "message_popup",
            popupData: {
                message: this.result.success_message,
                onOpen,
            },
        });
    },

    setError(error) {
        this.errors.__all__ = error;
    },

    resultHasErrors() {
        return this.result.form && Object.keys(this.result.form.errors).length !== 0;
    },

    getFormError() {
        if (Array.isArray(this.errors.__all__)) {
            return this.errors.__all__.join("<br/>");
        }
        return this.errors.__all__;
    },
};

const watch = {
    shouldClearErrors(newVal) {
        const hasErrors = Object.keys(this.errors).length;
        if (!newVal || !hasErrors) return;
        this.clearErrors();
    },
};

export default {
    props,
    data,
    template,
    methods,
    watch,
    emits: ["captchaFail"],
    name: "AjaxForm",
};
